import(/* webpackMode: "eager" */ "/builds/sympla/comprador/discovery-next/src/app/not-found.tsx");
